import { PhClipboardText } from '@phosphor-icons/vue'

import { websiteBlockMethods } from '@/features/website-builder/builder/blocks/common/methods'
import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import FormEditor from './editor/FormEditor.vue'
import {
  type FormSectionCreate,
  type FormSection,
  type FormSectionUpdate,
  type WebsiteResource,
} from './FormBlockModule.types'
import { createFormData } from './methods/createFormData'
import FormPreview from './preview/FormPreview.vue'
const i18n = i18nPlugin.global

export const FormBlockModule: BuilderBlockModule<
  FormSection,
  FormSectionCreate,
  FormSectionUpdate,
  WebsiteResource
> = {
  createData: createFormData,
  editor: FormEditor,
  meta: [
    {
      icon: PhClipboardText,
      key: 'form',
      label: i18n.t('website-builder.blocks.form'),
      sort: 5,
    },
  ],
  methods: websiteBlockMethods,
  preview: FormPreview,
}
